import { MenuItem } from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { useDiRef } from '@/common/react/di-hooks'
import type { ISpacesService } from '../services/SpacesService'
import type { SpaceGqlModel } from '../gql/SpaceGqlModel'

export interface SpaceOptionsPopoverProps {
  space: SpaceGqlModel
  canDelete: boolean
}

export function SpaceOptionsPopoverItems({ space, canDelete }: SpaceOptionsPopoverProps) {
  const spacesService = useDiRef<ISpacesService>('SpacesService')

  async function onDeleteClickedAsync() {
    if (!canDelete) {
      return
    }

    const { error } = await spacesService.deleteSpace(space.id)
    if (error) {
      console.error(`error deleting space id:${space.id}: ${error.message}`)
    }
    close()
  }

  return (
    <MenuItem
      disabled={!canDelete}
      data-testid="popover-delete"
      onClick={() => {
        void onDeleteClickedAsync()
      }}
      sx={{ color: 'error.main' }}
    >
      <DeleteOutlineIcon
        fontSize="small"
        sx={{ mr: 1 }}
        color={canDelete ? 'inherit' : 'disabled'}
      />
      Delete
    </MenuItem>
  )
}
